import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common'
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { EntityContainer } from 'src/app/tools/models/entityContainer';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ProductOption } from 'src/app/assabil-kernel/models/entities/master-data/product-option-entity';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';


@Component({
    selector: 'app-product-option-list',
    templateUrl: './product-option-list.component.html',
    styleUrls: ['./product-option-list.component.scss']
})


export class ProductOptionListComponent extends BasePage2<ProductOption>  {
    saveRow(row: import("../../../../../tools/models/baseEntity").BaseEntity): Promise<import("../../../../../tools/models/baseEntity").BaseEntity> {
        throw new Error("Method not implemented.");
    }

    getRows(): ProductOption[] {
        return this.productOptions;
    }
    initEntityContainer() {
        this.entityContainer = new EntityContainer(ProductOption);
    }


    newProductOption(){
     //   this.newEntity(new ProductOption());
    }

    productOptions                  : ProductOption[] = [];
    productOptionCodeFilter         : string;
    productCategoryCodeFilter       : string;
    productCategoryTypeCodeFilter   : string;
   


    constructor(
        protected masterDataService : MasterDataService,
        protected toastr            : ToastrService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected location          : Location) {
       
           super(toastr, router, baseService, leanUtilsService, location);

           this.entityName = 'productOption';
      }


    listFields = [
        { 
            prop: 'productOptionCode', 
            name: 'Code'
        },
        { 
            prop: 'name', 
            name: 'Name' 
        }
    ]
    formFields = this.listFields;

    loadData() {
        this.masterDataService.productOptionsGet(this.productOptionCodeFilter, this.productCategoryCodeFilter, this.productCategoryTypeCodeFilter).then(result => {
            this.productOptions = result;
        }).catch(error => {
            this.showError(error);
        })
    }

}
